export default {
    setCaracteristicasArray(state,car){
        state.caracteristicasArray = car
    }
}